import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles(theme => ({
  input: {
    display: "block",
    ...theme.typography.body1,
    lineHeight: "20px",
    width: "100%",
    height: "44px",
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(1.5, 1),
    boxSizing: "border-box",
    margin: props => props.margin || undefined,

    backgroundColor: props => (props.displayError ? "#FFEBE6" : "#FFF"),
    color: props => (props.displayError ? "#FF5630" : "#000"),

    "&:focus": {
      outline: "0 !important",
      boxShadow: props =>
        props.displayError
          ? "0px 0px 0px 4px rgba(242, 66, 53, 0.15)"
          : "0px 0px 0px 4px rgba(255, 171, 0, 0.15)",
      backgroundColor: "#FFF",
    },

    "&:hover": {
      border: props =>
        props.displayError ? "1px solid #FF5630" : "1px solid #ffab00",

      "::-webkit-input-placeholder": {
        color: "#454f5b",
      },

      "::-moz-placeholder": {
        color: "#454f5b",
      },

      ":-ms-input-placeholder": {
        color: "#454f5b",
      },

      ":-moz-placeholder": {
        color: "#454f5b",
      },
    },

    "&:active": {
      border: props =>
        props.displayError ? "1px solid #FF5630" : "1px solid #ffab00",
    },

    "::-webkit-input-placeholder": {
      color: theme.palette.text.textSecondary,
    },

    "::-moz-placeholder": {
      color: theme.palette.text.textSecondary,
    },

    ":-ms-input-placeholder": {
      color: theme.palette.text.textSecondary,
    },

    ":-moz-placeholder": {
      color: theme.palette.text.textSecondary,
    },
  },
  dropdownList: {
    position: "absolute",
    left: 0,
    right: 0,
    marginTop: theme.spacing(1),
    maxHeight: 232,
    backgroundColor: "#FFF",
    boxShadow:
      "0px 3px 5px rgba(33, 43, 54, 0.2), 0px 0px 1px rgba(33, 43, 54, 0.31)",
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(1, 0),
    overflow: "auto",
    zIndex: 5,
  },
  dropdownListItem: {
    padding: theme.spacing(0.75, 2),
    backgroundColor: "#fff",

    "&:hover": {
      cursor: "pointer",
      background: "#FFFCF4",
      backgroundColor: "##FFF0B3",
    },
  },
  errorWrapper: {
    width: "100%",
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(1),
    color: "#FF5630",
  },
  inputTextField: {
    width: "100%",
  },
  inputRemade: {
    height: 44,
    width: "100%",

    "& > p": {
      display: "none !important",
    },

    "& > div": {
      ...theme.typography.body1,
      lineHeight: "20px",
      borderRadius: 4,
      padding: theme.spacing(1.5, 1),
      height: "100%",

      "& > div": {
        display: "none !important",
      },

      "&:before": {
        display: "none !important",
      },

      "&:after": {
        display: "none !important",
      },

      "&:focus": {
        outline: "0 !important",
        boxShadow: props =>
          props.displayError
            ? "0px 0px 0px 4px rgba(242, 66, 53, 0.15)"
            : "0px 0px 0px 4px rgba(255, 171, 0, 0.15)",
        backgroundColor: "#FFF",
      },

      "&:hover": {
        border: props =>
          props.displayError ? "1px solid #FF5630" : "1px solid #ffab00",

        "::-webkit-input-placeholder": {
          color: "#454f5b",
        },

        "::-moz-placeholder": {
          color: "#454f5b",
        },

        ":-ms-input-placeholder": {
          color: "#454f5b",
        },

        ":-moz-placeholder": {
          color: "#454f5b",
        },
      },

      "&:active": {
        border: props =>
          props.displayError ? "1px solid #FF5630" : "1px solid #ffab00",
      },

      "::-webkit-input-placeholder": {
        color: theme.palette.text.textSecondary,
      },

      "::-moz-placeholder": {
        color: theme.palette.text.textSecondary,
      },

      ":-ms-input-placeholder": {
        color: theme.palette.text.textSecondary,
      },

      ":-moz-placeholder": {
        color: theme.palette.text.textSecondary,
      },
    },
  },
}))

export default useStyles
